import { render, staticRenderFns } from "./IconDialogue.vue?vue&type=template&id=3f394406"
import script from "./IconDialogue.vue?vue&type=script&lang=js"
export * from "./IconDialogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports